import { render, staticRenderFns } from "./ChildRoute.vue?vue&type=template&id=24c63f0f&scoped=true&"
import script from "./ChildRoute.vue?vue&type=script&lang=js&"
export * from "./ChildRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c63f0f",
  null
  
)

export default component.exports